import style from "./style.scss";

import { Fragment } from "preact";
import { useId } from "preact/hooks";
import { usePopup } from "../popup/context";
import Popup from "../popup";
import Link from "../link";
import Editorial from "../editorial";
import AffiliateDisclosureContent from "./content";

const AffiliateDisclosure = ({ brandSent = true }) => {
  const popup = usePopup();
  const modalTitleId = useId();

  const openDetails = (e) => {
    e.preventDefault();

    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            <h2 id={modalTitleId}>Affiliate Links & Product Reviews</h2>
            <AffiliateDisclosureContent />
          </Editorial>
        </div>
      </Popup>
    );
  };

  const text = `My opinions, not brand-directed. Uses affiliate links. ${brandSent ? "Brands send some review items. " : ""}`;

  return (
    <Fragment>
      <p class={style.disclosure}>
        {text}{" "}
        <Link href="#" onClick={(e) => openDetails(e)}>
          See details
        </Link>
      </p>
    </Fragment>
  );
};

export default AffiliateDisclosure;
